import React from 'react';
import PropTypes from 'prop-types';

import VarexeLogo from 'components/common/VarexeLogo';
import { Flex, Typography } from 'antd';

const { Text } = Typography;

const toCssSize = (value) => (typeof value === 'number' ? `${value}px` : value);

const Logo = ({
  at = 'auth',
  width,
  imageSize,
  fontSize = '1.1rem',
  taglineFontSize = '0.75rem',
  hideTitleTaglineOnMobile = true,
  className,
  textClass,
  ...rest
}) => {
  const resolvedImageSize = imageSize ?? width ?? 35;
  const containerWidth = width ?? resolvedImageSize;
  const titleFontSize = toCssSize(fontSize);
  const subtitleFontSize = toCssSize(taglineFontSize);
  const mobileTextVisibility = hideTitleTaglineOnMobile ? 'd-none d-sm-block' : '';

  return (
    <div className={className} {...rest}>
      <Flex className="text-left" gap="small">
        <div style={{ width: containerWidth, flexShrink: 0 }}>
          <VarexeLogo
            type="svg"
            style={{ width: resolvedImageSize, marginTop: 0 }}
            className="fs-1"
          />
        </div>
        <div className="text-start">
          <Typography.Title
            level={4}
            className={`mb-0 ${mobileTextVisibility} text-primary text-start app-brand-wordmark ${textClass || ''}`}
            style={{
              marginLeft: '3px',
              marginTop: '2px',
              lineHeight: 1,
              fontWeight: 500,
              fontSize: titleFontSize,
            }}
          >
            Gridbind
          </Typography.Title>
          <Text
            className={`mb-0 ${mobileTextVisibility} ms-1 text-600 app-brand-wordmark ${textClass || ''}`}
            style={{ fontSize: subtitleFontSize, lineHeight: 1.2 }}
          >
            Business Operations Suite
          </Text>
        </div>
      </Flex>
    </div>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  imageSize: PropTypes.number,
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  taglineFontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  textClass: PropTypes.string,
  hideTitleTaglineOnMobile: PropTypes.bool,
};

export default Logo;
